<template>
  <div class="shopifyTasksContainer">
    <TeeInBlueBearerDialog />
    <div v-if="!shopifyTasksLoading">
      <div
        :class="
          navigationExpanded
            ? 'functions-header functions-header--expanded'
            : 'functions-header'
        "
      >
        <v-row dense>
          <v-col cols="12" md="auto">
            <div class="d-flex justify-start align-center">
              <!-- Typ-Auswahl: welche Tasks — Alle | Manuell (Standard) | Auto (Auto-Import eingeplant) | geflaggt -->
              <div class="typeTabs">
                <div class="tglPill tglPill--mini" :class="{ 'tglPill--active': typeTab === 'all' }" title="Alle offenen Imports" @click="setTypeTab('all')">
                  Alle
                  <span class="tglPill__count">{{ unmarkedTaskIdsLength }}</span>
                </div>
                <div
                  class="tglPill tglPill--mini"
                  :class="{ 'tglPill--active': typeTab === 'manual' }"
                  title="Tasks, die von Hand importiert werden: nicht bestanden, ohne Score, gestoppt oder ausgeschlossen"
                  @click="setTypeTab('manual')"
                >
                  <v-icon x-small>mdi-hand-back-right-outline</v-icon> Manuell
                  <span class="tglPill__count">{{ unmarkedTaskIdsLength - autoImportTaskIdsLength }}</span>
                </div>
                <div class="tglPill tglPill--mini" :class="{ 'tglPill--active': typeTab === 'auto' }" title="Tasks, die automatisch importiert werden" @click="setTypeTab('auto')">
                  <v-icon x-small>mdi-timer-outline</v-icon> Auto
                  <span class="tglPill__count">{{ autoImportTaskIdsLength }}</span>
                </div>
                <div class="tglPill tglPill--mini" :class="{ 'tglPill--active': typeTab === 'marked' }" title="Geflaggte Imports" @click="setTypeTab('marked')">
                  <v-icon x-small>mdi-flag</v-icon>
                  <span class="tglPill__count">{{ markedTaskIdsLength }}</span>
                </div>
              </div>

              <span class="qfDivider" />

              <div
                class="tglPill tglPill--mini"
                :class="{ 'tglPill--active': quickFilter === 'express' }"
                @click="toggleQuickFilter('express')"
                title="Nur Express-Tasks"
              >
                <v-icon x-small>mdi-flash</v-icon> Express
                <span class="tglPill__count">{{ quickCounts.express }}</span>
              </div>
              <div
                class="tglPill tglPill--mini"
                :class="{ 'tglPill--active': quickFilter === 'note' }"
                @click="toggleQuickFilter('note')"
                title="Nur Tasks mit Order-Note"
              >
                <v-icon x-small>mdi-comment-text-outline</v-icon> Comment
                <span class="tglPill__count">{{ quickCounts.note }}</span>
              </div>
              <div
                class="tglPill tglPill--mini"
                :class="{ 'tglPill--active': quickFilter === 'quelp' }"
                @click="toggleQuickFilter('quelp')"
                title="Nur Tasks mit Quelp-/Support-Nachricht"
              >
                <v-icon x-small>mdi-headset</v-icon> Quelp
                <span class="tglPill__count">{{ quickCounts.quelp }}</span>
              </div>
              <!-- Platzhalter mit aktivem Änderungslink (Kunde ändert sein Bild selbst) -->
              <div
                class="tglPill tglPill--mini"
                :class="{ 'tglPill--active': quickFilter === 'edit' }"
                @click="toggleQuickFilter('edit')"
                :title="quickCounts.editExpired ? `Tasks mit Änderungslink, davon ${quickCounts.editExpired} abgelaufen` : 'Tasks, die auf eine Kundenänderung warten'"
              >
                <v-icon x-small>mdi-image-edit-outline</v-icon> Änderung
                <span class="tglPill__count" :class="{ 'tglPill__count--alert': quickCounts.editExpired }">{{ quickCounts.edit }}</span>
              </div>
              <v-menu
                v-model="countryMenu"
                offset-y
                :close-on-content-click="false"
                max-height="420"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="tglPill tglPill--mini"
                    :class="{ 'tglPill--active': selectedCountries.length > 0 }"
                    v-bind="attrs"
                    v-on="on"
                    title="Nach Lieferland filtern"
                  >
                    <template v-if="selectedCountries.length">
                      <span class="countryPill__flags">{{ selectedCountryFlags }}</span>
                    </template>
                    <template v-else>
                      <v-icon x-small>mdi-earth</v-icon> Land
                    </template>
                    <v-icon x-small>mdi-chevron-down</v-icon>
                  </div>
                </template>
                <v-list dense class="countryList">
                  <v-list-item
                    v-if="selectedCountries.length"
                    class="countryList__reset"
                    @click="selectedCountries = []"
                  >
                    <v-icon small class="mr-2">mdi-close-circle-outline</v-icon>
                    Filter zurücksetzen
                  </v-list-item>
                  <v-list-item
                    v-for="option in countryOptions"
                    :key="option.code"
                    @click="toggleCountry(option.code)"
                  >
                    <v-simple-checkbox
                      :value="selectedCountries.includes(option.code)"
                      color="#7b5cd6"
                      class="mr-1"
                      @click.stop="toggleCountry(option.code)"
                    />
                    <span class="countryList__flag">{{ option.flag }}</span>
                    <span class="countryList__name">{{ option.name }}</span>
                    <span class="tglPill__count ml-auto">{{ option.count }}</span>
                  </v-list-item>
                  <v-list-item v-if="!countryOptions.length" disabled>
                    Keine Länderdaten vorhanden
                  </v-list-item>
                </v-list>
              </v-menu>
              <!-- Upscale-Jobs: laufende + letzte 24 h -->
              <UpscalesButton />
              <!-- Einstellungen des Imports (Auto-Import: Zeiten, Wartezeit, an/aus) -->
              <v-btn icon small class="ml-1" title="Import-Einstellungen" to="/manager/import">
                <v-icon small>mdi-cog-outline</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col v-show="showAssignee" cols="12" md="auto" class="d-flex align-center">
            <v-autocomplete
              v-show="showAssignee"
              :items="allDrawers"
              dense
              rounded
              item-text="label"
              item-value="uid"
              outlined
              label="Assignee"
              hide-details
              class="assigneeSelect"
              :value="selectedAssignee"
              @input="setSelectedAssignee"
              return-object
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md class="headerSearch">
            <v-text-field
              v-model="searchTerm"
              append-icon="mdi-magnify"
              placeholder="Order Number, Name or Email"
              type="text"
              hide-details
              dense
              rounded
              solo flat
              background-color="#f4f3f7"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-expansion-panels v-model="openPanels" class="shop-tabs" :multiple="true">
        <v-expansion-panel>
          <v-expansion-panel-header class="e-panel-header">
            <div class="e-panel-header__count">{{ qfTasksLive.length }}</div>
            <div class="e-panel-header__name"> Live Editor </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <CardsGrid
                v-if="qfTasksLive.length"
                :cols="gridCols"
                :tasks="qfTasksLive"
                :selected-assignee="selectedAssignee"
                :selected-edit-style="selectedEditStyle"
                :CardComponent="liveCardComponent"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="e-panel-header">
            <div class="e-panel-header__count">{{ qfTasksOH.length }}</div>
            <div class="e-panel-header__name"> OhMyArt (US, CA) </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <CardsGrid
                v-if="qfTasksOH.length"
                :cols="gridCols"
                :tasks="qfTasksOH"
                :selected-assignee="selectedAssignee"
                :selected-edit-style="selectedEditStyle"
                :CardComponent="cardComponent"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="e-panel-header">
            <div class="e-panel-header__count">{{ qfTasksAQ.length }}</div>
            <div class="e-panel-header__name"> Artquarell (DE,FR,ES) </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <CardsGrid
              v-if="qfTasksAQ.length"
              :cols="gridCols"
              :tasks="qfTasksAQ"
              :selected-assignee="selectedAssignee"
              :selected-edit-style="selectedEditStyle"
              :CardComponent="cardComponent"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="e-panel-header">
            <div class="e-panel-header__count">{{ qfTasksTM.length }}</div>
            <div class="e-panel-header__name"> TierBeiMir (DE) </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <CardsGrid
              v-if="qfTasksTM.length"
              :cols="gridCols"
              :tasks="qfTasksTM"
              :CardComponent="cardComponent"
              :selected-assignee="selectedAssignee"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <StateDisplay v-else :loading="shopifyTasksLoading" />
  </div>
</template>
<script>
import ImportTaskCard from "@/components/TaskCards/ImportTaskCard";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {editStyles, permissions} from "@/constants";
import TeeInBlueBearerDialog from "@/components/TeeInBlueBearerDialog";
import CardsGrid from "@/components/CardsGrid";
import StateDisplay from "@/components/StateDisplay";
import {EventBus, events} from "../../event-bus";
import {delay, countryFlagEmoji, countryNameDe} from "@/utils";
import ImportLiveTaskCard from "@/components/TaskCards/ImportLiveTaskCard.vue";
import UpscalesButton from "@/components/Upscales/UpscalesButton.vue";

export default {
  components: { StateDisplay, CardsGrid, TeeInBlueBearerDialog, UpscalesButton },
  data() {
    return {
      searchTerm: "",
      stopRemovePreview: false,
      gridCols: {
        cols: "12",
        sm: "6",
        md: "6",
        lg: "4",
      },
      selectedEditStyle: editStyles[0],
      editStyles: editStyles,
      cardComponent: ImportTaskCard,
      liveCardComponent: ImportLiveTaskCard,
      quickFilter: null, // 'express' | 'note' | 'quelp'
      importMode: "manual", // 'manual' | 'auto' | null (alle) — Auto = Auto-Import eingeplant
      selectedCountries: [], // Lieferland-Filter (Mehrfachauswahl, ISO-Codes)
      countryMenu: false,
      openPanels: [], // aufgeklappte Shop-Panels (0 = Live Editor)
    };
  },
  computed: {
    ...mapGetters([
      "orderIdsInSupport",
      "unmarkedTaskIdsLength",
      "shopifyTasksAQ",
      "shopifyTasksTM",
      "shopifyTasksOH",
      "shopifyTasksLive",
      "shopifyTasksLoading",
      "shopifyTaskFilter",
      "allUsers",
      "selectedAssignee",
      "navigationExpanded",
      "markedTaskIdsLength",
      "autoImportTaskIdsLength",
      "selectedShopId",
      "drawTasksPerUser",
      "userNameIdMap",
    ]),
    selectedTab: {
      get() {
        return this.selectedShopId;
      },
      set(value) {
        this.setSelectedShopId(value);
      },
    },
    liveEditorPanelOpen() {
      return this.openPanels.includes(0);
    },
    /** Typ-Tabber: geflaggt kommt aus dem Store-Filter, Manuell/Auto aus importMode */
    typeTab() {
      if (this.shopifyTaskFilter === "marked") return "marked";
      return this.importMode || "all";
    },
    quickCounts() {
      const all = [
        ...this.shopifyTasksLive,
        ...this.shopifyTasksOH,
        ...this.shopifyTasksAQ,
        ...this.shopifyTasksTM,
      ];
      const inSupport = new Set((this.orderIdsInSupport || []).map(String));
      return {
        express: all.filter((t) => t.productType?.isExpress).length,
        note: all.filter((t) => t.orderNote && String(t.orderNote).trim()).length,
        quelp: all.filter((t) => inSupport.has(String(t.orderId))).length,
        edit: all.filter((t) => t.awaitingCustomerEdit).length,
        editExpired: all.filter((t) => t.awaitingCustomerEdit && Date.now() >= Number(t.awaitingCustomerEdit.expiresAt || 0)).length,
      };
    },
    countryOptions() {
      // Vorkommende Lieferländer über alle Panels, mit Task-Anzahl,
      // absteigend nach Häufigkeit. Alt-Tasks ohne shippingCountryCode
      // tauchen nicht als Option auf.
      const counts = {};
      for (const t of [
        ...this.shopifyTasksLive,
        ...this.shopifyTasksOH,
        ...this.shopifyTasksAQ,
        ...this.shopifyTasksTM,
      ]) {
        const cc = String(t.shippingCountryCode || "").toUpperCase();
        if (!/^[A-Z]{2}$/.test(cc)) continue;
        counts[cc] = (counts[cc] || 0) + 1;
      }
      return Object.entries(counts)
        .map(([code, count]) => ({
          code,
          count,
          flag: countryFlagEmoji(code),
          name: countryNameDe(code),
        }))
        .sort((a, b) => b.count - a.count || a.name.localeCompare(b.name));
    },
    selectedCountryFlags() {
      return this.selectedCountries.map(countryFlagEmoji).join(" ");
    },
    showAssignee() {
      // Nur relevant, wenn ein klassisches Shop-Panel offen ist —
      // bei Live Editor oder komplett zugeklappt ausblenden
      return this.openPanels.length > 0 && !this.liveEditorPanelOpen;
    },
    qfTasksLive() {
      return this.applyQuickFilter(this.shopifyTasksLive);
    },
    qfTasksOH() {
      return this.applyQuickFilter(this.shopifyTasksOH);
    },
    qfTasksAQ() {
      return this.applyQuickFilter(this.shopifyTasksAQ);
    },
    qfTasksTM() {
      return this.applyQuickFilter(this.shopifyTasksTM);
    },
    allDrawers() {
      const allUsersAllowedToDraw = this.allUsers
        .filter((user) => user.permissions.includes(permissions.TASK_DRAWING))
        .map((user) => {
          return {
            ...user,
            label: `${user.username} (${this.drawTasksPerUser[user.uid] || 0})`,
          };
        });
      return [
        {
          label: "-",
          uid: "",
        },
        ...allUsersAllowedToDraw,
      ];
    },
  },
  watch: {
    searchTerm() {
      this.setSearchTerm(this.searchTerm);
    },
  },
  mounted() {
    this.loadTasksFromShopify();
    // Add event listener when the component is mounted
    EventBus.$on(events.STOP_REMOVE_TEMPLATES, this.stopRemoveAllPreviews)
  },
  beforeDestroy() {
    // Remove event listener to avoid memory leaks
  },
  methods: {
    ...mapActions(["loadTasksFromShopify"]),
    ...mapMutations([
      "setSearchTerm",
      "setSearchFilter",
      "setSelectedAssignee",
      "setSelectedShopId",
    ]),
    toggleQuickFilter(f) {
      this.quickFilter = this.quickFilter === f ? null : f;
    },
    toggleCountry(code) {
      this.selectedCountries = this.selectedCountries.includes(code)
        ? this.selectedCountries.filter((c) => c !== code)
        : [...this.selectedCountries, code];
    },
    /** Auto-Import eingeplant (task.autoImport schreibt der Server) */
    isAutoImport(task) {
      return !!task.autoImport && task.autoImport.state === "scheduled";
    },
    setTypeTab(tab) {
      this.setSearchFilter(tab === "marked" ? "marked" : "unmarked");
      if (tab !== "marked") this.importMode = tab === "all" ? null : tab;
    },
    applyQuickFilter(list) {
      // Manuell/Auto gilt nicht im Reiter „geflaggt" und nicht bei „Alle"
      const mode = this.typeTab === "manual" || this.typeTab === "auto" ? this.typeTab : null;
      let result = mode ? list.filter((t) => this.isAutoImport(t) === (mode === "auto")) : list;
      if (this.selectedCountries.length) {
        result = result.filter((t) =>
          this.selectedCountries.includes(
            String(t.shippingCountryCode || "").toUpperCase()
          )
        );
      }
      if (!this.quickFilter) return result;
      if (this.quickFilter === "express") {
        return result.filter((t) => t.productType?.isExpress);
      }
      if (this.quickFilter === "note") {
        return result.filter((t) => t.orderNote && String(t.orderNote).trim());
      }
      if (this.quickFilter === "edit") {
        return result.filter((t) => t.awaitingCustomerEdit);
      }
      // quelp: Order hat ein offenes/wartendes Support-Ticket
      const inSupport = new Set((this.orderIdsInSupport || []).map(String));
      return result.filter((t) => inSupport.has(String(t.orderId)));
    },
    async upscaleUltraALl() {
      console.log('START UPSCALE ALL')
      for await (const task of this.shopifyTasksAQ) {
        if (task.img && !task.previewExists && !task.removed) {
          EventBus.$emit(events.ULTRA_UPSCALE_BY_ID + task.uid)
          await delay(Math.floor(Math.random() * (5000 - 1000 + 1)) + 1000)
        }
      }
    },
    async stopRemoveAllPreviews() {
      console.log('STOP GENERATING TEMPLATES')
      this.stopRemovePreview = true
      await delay(3000)
      this.stopRemovePreview = false
    },
    async removeAllPreviews() {
      for await (const task of this.shopifyTasksAQ) {
        if (this.stopRemovePreview) {
          break;
        }
        if (!task.removed) {
          EventBus.$emit(events.REMOVE_TEMPLATE_PREVIEW_BY_ID + task.uid)
          await delay(Math.floor(Math.random() * (1500 - 500 + 1)) + 1000)
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.shopifyTasksContainer {
  min-height: 500px;
}
.functions-header {
  position: fixed;
  z-index: 4;
  background-color: white;
  width: calc(100% - 80px);
  padding-top: 20px;
  padding-left: 20px;
  padding-bottom: 12px;
  top: 60px;
  left: 60px;
  box-shadow: 0 6px 14px -8px rgba(16, 24, 40, 0.12);
  transition: margin-left ease 200ms;

  &--expanded {
    margin-left: 200px;
    transition: margin-left ease 200ms;
  }
}

.shop-tabs {
  padding-top: 78px;

  @media (max-width: 959px) {
    padding-top: 190px;
  }
}

.e-panel-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;

  &__count {
    flex: 0 0 auto !important;
    width: fit-content;
    max-width: fit-content;
    min-width: 30px;
    text-align: center;
    font-size: 12px;
    font-weight: 700 !important;
    background: #edeafa;
    color: #6a4fc4;
    border-radius: 999px;
    padding: 3px 10px;
  }

  &__name {
    font-weight: 700 !important;
    flex: 1 1 auto;
    text-align: left;
  }
}

.task-view {
  margin-top: 12px;
}

/* Filter-Toggle im Pill-Stil der Tabs */
.tglPill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 16px;
  margin: 0 3px;
  border-radius: 999px;
  font-size: 13.5px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.55);
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;

  .v-icon {
    color: inherit !important;
  }

  &:hover {
    background: #f4f3f7;
  }

  &--active {
    background: rgba(123, 92, 214, 0.12);
    color: #7b5cd6;
  }

  &__count {
    font-size: 11px;
    font-weight: 700;
    background: #edeafa;
    color: #6a4fc4;
    border-radius: 999px;
    padding: 1px 8px;
  }

  &--mini {
    height: 32px;
    padding: 0 12px;
    font-size: 12.5px;
  }
}

.assigneeSelect {
  max-width: 220px;

  ::v-deep .v-input__slot {
    min-height: 38px !important;
  }
}

/* Typ-Tabber: zusammenhängende Gruppe, klar abgesetzt von den Filtern daneben */
.typeTabs {
  display: inline-flex;
  align-items: center;
  padding: 3px;
  border-radius: 999px;
  background: #f4f3f7;

  .tglPill {
    margin: 0;

    &:hover {
      background: rgba(255, 255, 255, 0.7);
    }
    &--active,
    &--active:hover {
      background: #fff;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.14);
    }
  }
}

.headerSearch {
  min-width: 220px;
}

.qfDivider {
  width: 1px;
  height: 22px;
  background: rgba(0, 0, 0, 0.1);
  margin: 0 8px;
}

.countryPill__flags {
  font-size: 15px;
  line-height: 1;
  letter-spacing: 2px;
}

.countryList {
  min-width: 230px;

  &__flag {
    font-size: 17px;
    margin-right: 8px;
    line-height: 1;
  }

  &__name {
    font-size: 13px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.75);
  }

  &__reset {
    font-size: 12.5px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.55);
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
}

.download-type-display {
  background: black;
  color: white;
}
</style>
